export const TIPO_CONTRATO_LABELS = {
  // Navigation
  administration: 'Administración',
  tiposContrato: 'Tipos de Contrato',

  // Actions
  createTipoContrato: 'Crear Tipo de Contrato',
  editTipoContrato: 'Editar Tipo de Contrato',
  save: 'Guardar',
  cancel: 'Cancelar',
  close: 'Cerrar',

  // Form fields
  tipoContratoId: 'ID de Tipo de Contrato',
  nombre: 'Nombre',

  // Table
  tableId: 'ID',
  tableNombre: 'Nombre',
  tableActions: 'Acciones',

  // Messages
  loadingTiposContrato: 'Cargando tipos de contrato...',
  noTiposContrato: 'No hay tipos de contrato disponibles',

  // Tooltips
  tooltipEdit: 'Editar tipo de contrato',
  tooltipView: 'Ver detalles del tipo de contrato',
  tooltipDelete: 'Eliminar tipo de contrato'
} as const;
